import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Remove } from "@conserveit/blocks";
import {
  AttachmentPreviewItem,
  RemoveButton,
} from "./AttachmentsPreview.styled";

const AttachmentPreviewFile = ({ onDelete, attachment }) => {
  function handleDelete() {
    onDelete(attachment);
  }

  return (
    <RemoveButton onClick={handleDelete} title="Remove attachment">
      <Remove tiny />
    </RemoveButton>
  );
};

AttachmentPreviewFile.propTypes = {
  onDelete: PropTypes.func.isRequired,
  attachment: PropTypes.shape({
    key: PropTypes.number,
    fileName: PropTypes.string,
  }).isRequired,
};

const AttachmentsPreview = ({
  attachments,
  handleRemoveAttachment,
  isRemoveVisible,
}) => {
  if (attachments.length === 0) return null;

  return (
    <Fragment>
      {attachments.map((attachment) => (
        <AttachmentPreviewItem key={attachment.key}>
          {isRemoveVisible && (
            <AttachmentPreviewFile
              onDelete={handleRemoveAttachment}
              attachment={attachment}
            />
          )}
          {attachment.fileName}
        </AttachmentPreviewItem>
      ))}
    </Fragment>
  );
};

AttachmentsPreview.propTypes = {
  isRemoveVisible: PropTypes.bool,
  attachments: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleRemoveAttachment: PropTypes.func.isRequired,
};

AttachmentsPreview.defaultProps = {
  isRemoveVisible: true,
};

export default AttachmentsPreview;
